export const urlPaths = {
  logout: '/logout',
  login: '/login',
  registration: '/registration',
  home: '/',
  apply: '/apply',
  applyIdentityVerification: '/apply/identityVerification',
  applyPersonalDetails: '/apply/personalDetails',
  applyBusinessList: '/apply/businessList',
  applyBusinessDetails: '/apply/businessDetails',
  applyBusinessAddress: '/apply/businessAddress',
  applyBusinessDirectors: '/apply/businessDirectors',
  applyBusinessFinancial: '/apply/businessFinancial',
  applyDocumentDetails: '/apply/documentDetails',
  applyFinancialDetails: '/apply/financialDetails',
  applyFundingDetails: '/apply/fundingDetails',
  submit: '/submit',
  accounts: '/accounts',
  accountsBta: '/accounts/bta',
  accountsCapitalFacility: '/accounts/cash-flow-facility',
  accountsCapitalFacilityWithdrawal: '/accounts/cash-flow-facility/withdrawal',
  applications: '/applications',
  quote: '/quote',
  profile: '/profile',
  profilePersonalDetails: '/profile/personalDetails',
  profilePersonalAddress: '/profile/personalAddress',
  profileBusinessAddress: '/profile/businessAddress',
  profileBusinessDetails: '/profile/businessDetails',
  profileDirectorDetails: '/profile/directorDetails',
  profileDocumentDetails: '/profile/documentDetails'
};

export const journeyName = {
  [urlPaths.quote]: 'bta funding quote',
  [urlPaths.accountsCapitalFacilityWithdrawal]: 'cash flow facility'
};

export const pageName = {
  [urlPaths.quote]: 'bta quote',
  [urlPaths.logout]: 'logout',
  [urlPaths.login]: 'login',
  [urlPaths.registration]: 'registration',
  [urlPaths.home]: 'home',
  [urlPaths.apply]: 'apply',
  [urlPaths.applyIdentityVerification]: 'identity verification',
  [urlPaths.applyPersonalDetails]: 'business representative details',
  [urlPaths.applyBusinessList]: 'apply business list',
  [urlPaths.applyBusinessDetails]: 'apply business details',
  [urlPaths.applyBusinessAddress]: 'apply business address',
  [urlPaths.applyBusinessDirectors]: 'apply business directors',
  [urlPaths.applyBusinessFinancial]: 'apply business financial',
  [urlPaths.applyDocumentDetails]: 'apply document details',
  [urlPaths.applyFinancialDetails]: 'apply financial details',
  [urlPaths.applyFundingDetails]: 'apply funding details',
  [urlPaths.submit]: 'submit',
  [urlPaths.accounts]: 'accounts',
  [urlPaths.accountsBta]: 'accounts bta',
  [urlPaths.accountsCapitalFacility]: 'accounts cash flow facility',
  [urlPaths.accountsCapitalFacilityWithdrawal]: 'cash flow facility',
  [urlPaths.applications]: 'applications',
  [urlPaths.profile]: 'profile',
  [urlPaths.profilePersonalDetails]: 'profile personal details',
  [urlPaths.profilePersonalAddress]: 'profile personal address',
  [urlPaths.profileBusinessAddress]: 'profile business address',
  [urlPaths.profileBusinessDetails]: 'profile business details',
  [urlPaths.profileDirectorDetails]: 'profile director details',
  [urlPaths.profileDocumentDetails]: 'profile document details'
};
